var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhinditMonoCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "163.08 240 1093.82 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1420,
    height: 780
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m957.05,389.99c0,29.2-23.76,52.96-52.96,52.96s-52.96-23.76-52.96-52.96,23.76-52.96,52.96-52.96,52.96,23.76,52.96,52.96m0-149.98v76.3c-15.48-11.16-33.71-17.04-52.96-17.04-24.24,0-47.02,9.44-64.15,26.57-17.14,17.13-26.58,39.92-26.58,64.16s9.44,47.02,26.58,64.15c17.13,17.14,39.91,26.58,64.15,26.58,20.51,0,39.86-6.68,55.95-19.3,2.87-2.25,5.63-4.7,8.2-7.27,17.14-17.13,26.58-39.92,26.58-64.16v-149.98h-37.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.83,442.95c-29.2,0-52.96-23.76-52.96-52.96s23.75-52.96,52.96-52.96,52.96,23.75,52.96,52.96-23.75,52.96-52.96,52.96m83.87-87.71c-4.5-10.87-11.15-20.84-19.72-29.41-17.13-17.13-39.92-26.57-64.16-26.57s-47.02,9.44-64.16,26.57c-17.14,17.13-26.58,39.92-26.58,64.16v150.01h37.77v-76.33c15.47,11.17,33.7,17.05,52.96,17.05,24.24,0,47.02-9.44,64.16-26.58,17.14-17.13,26.57-39.91,26.57-64.16,0-12.12-2.36-23.88-6.86-34.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m540.06,389.98v90.73h-37.77v-90.73c0-29.2-23.75-52.96-52.96-52.96s-52.96,23.76-52.96,52.96v90.73h-37.77v-240.71h37.77v76.3c15.48-11.17,33.71-17.05,52.96-17.05,24.24,0,47.02,9.44,64.15,26.57,17.14,17.14,26.58,39.92,26.58,64.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m799.28,389.98v90.69l-1.89.04h-35.85l-.04-1.89v-88.09c0-14.62-5.74-28.32-16.17-38.56-10.18-10.01-23.6-15.38-37.73-15.14-28.68.5-52.02,24.26-52.02,52.94v90.69l-1.89.04h-35.85l-.04-1.89v-88.84c0-50.02,40.71-90.73,90.73-90.73,24.24,0,47.02,9.44,64.16,26.57,17.14,17.14,26.58,39.92,26.58,64.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 560.05,
    y: 314.07,
    width: 37.77,
    height: 166.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m602.48,264.07c0,13.28-10.8,24.07-24.07,24.07s-24.07-10.79-24.07-24.06,10.8-24.08,24.07-24.08,24.07,10.8,24.07,24.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1014.83,
    y: 314.07,
    width: 37.77,
    height: 166.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1110.37,355.32v.6h-1.25c.41-.2.83-.41,1.25-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1110.37,355.32v.6h-1.25c.41-.2.83-.41,1.25-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1057.25,264.07c0,13.28-10.8,24.07-24.07,24.07s-24.07-10.79-24.07-24.06,10.8-24.08,24.07-24.08,24.07,10.8,24.07,24.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1204.27,414.89c0,36.35-29.47,65.84-65.83,65.84-30.74,0-56.56-21.07-63.81-49.55-1.32-5.21-2.03-10.67-2.03-16.29v-150.36h37.77v53.62h76.87v37.78h-76.87v-.6c-.42.19-.84.4-1.25.6h1.25v58.96c0,15.47,12.59,28.06,28.07,28.06s28.06-12.59,28.06-28.06h37.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1110.37,355.32v.6h-1.25c.41-.2.83-.41,1.25-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1256.9,457.89c0,13.28-10.8,24.07-24.07,24.07s-24.07-10.79-24.07-24.07,10.8-24.07,24.07-24.07,24.07,10.8,24.07,24.07"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhinditMonoCropped);
export default __webpack_public_path__ + "static/media/Phindit_Mono-cropped.5f4a3165a397ec1794674defbc257195.svg";
export { ForwardRef as ReactComponent };